// All comments in English.
export default function TrendIndicator({ value }: { value: number }) {
  if (value > 0) {
    return <span className="text-emerald-600">▲ {value.toFixed(2)}</span>;
  } else if (value < 0) {
    return <span className="text-red-600">▼ {value.toFixed(2)}</span>;
  }
  return <span className="text-gray-600">—</span>;
}
